import ChatInterface from "@/components/feature/Chat/ChatInterface"
import { Layout } from "@/components/layout"
import "react-loading-skeleton/dist/skeleton.css"

const Chat: React.FC = () => {
  return (
    <Layout>
      <ChatInterface />
    </Layout>
  )
}

export default Chat
